import { DatePicker, InputNumber } from "antd";
import dayjs from "dayjs";
import SimpleTablePage from "../common/SimpleTablePage";
import DebounceSelect from "../common/DebounceSelect";
import { api } from "../common/api";
import { date2locale } from "../common/common";

const columns = [
  {
    title: "Dipendente",
    key: "employee",
    dataIndex: "employee",
    render: (employee) =>
      employee?.fullName ?? `${employee?.firstName ?? ""} ${employee?.lastName ?? ""}`,
    sorter: true,
    ellipsis: true,
    width: 250,
  },
  {
    title: "DPI",
    key: "dpi",
    dataIndex: "dpi",
    render: (dpi) => dpi?.name,
    sorter: true,
    ellipsis: true,
    width: 250,
  },
  {
    title: "Ultima consegna",
    key: "latestDeliveryDate",
    dataIndex: "latestDeliveryDate",
    render: (date) => (date ? date2locale(date) : "-"),
    sorter: true,
    width: 180,
  },
  {
    title: "Consegnati",
    key: "stock",
    dataIndex: "stock",
    render: (stock) => stock ?? "-",
    sorter: true,
    width: 150,
  },
];

const entityFilter = (name, label, resource, getLabel) => ({
  name,
  label,
  readableValue: (value) => value && JSON.parse(value).label,
  formItem: {
    props: {
      getValueProps: (value) => ({ value: value && JSON.parse(value) }),
      normalize: (value) => value && JSON.stringify(value),
    },
    children: (
      <DebounceSelect
        allowClear
        minSize={0}
        fetchOptions={(query) =>
          api[resource]
            .list({ query, pageSize: 9999 })
            .then(({ data }) => data.map((item) => ({ label: getLabel(item), value: item.id })))
        }
      />
    ),
  },
});

const dateFilter = (name, label) => ({
  name,
  label,
  readableValue: date2locale,
  formItem: {
    props: {
      getValueProps: (value) => ({ value: value ? dayjs(value) : null }),
      normalize: (value) => value?.format("YYYY-MM-DD"),
    },
    children: <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />,
  },
});

const filterItems = [
  entityFilter("employee", "Dipendente", "employee", (employee) => employee.fullName),
  entityFilter("dpi", "DPI", "dpi", (dpi) => dpi.name),
  dateFilter("startDeliveryDate", "Ultima consegna dal"),
  dateFilter("endDeliveryDate", "Ultima consegna al"),
  {
    name: "minStock",
    label: "Giacenza minima",
    formItem: { children: <InputNumber precision={0} style={{ width: "100%" }} /> },
  },
  {
    name: "maxStock",
    label: "Giacenza massima",
    formItem: { children: <InputNumber precision={0} style={{ width: "100%" }} /> },
  },
];

const fetchDpis = (params) =>
  api.employeeRequiredDpi.list({
    ...params,
    employee: params.employee ? JSON.parse(params.employee).value : undefined,
    dpi: params.dpi ? JSON.parse(params.dpi).value : undefined,
  });

export default function EmployeeRequiredDpis() {
  return (
    <SimpleTablePage
      title="DPI obbligatori"
      description="Consulta i DPI richiesti per i dipendenti, le ultime consegne e le giacenze"
      resource="employeeRequiredDpi"
      columns={columns}
      filterItems={filterItems}
      fetchFunction={fetchDpis}
      rowKey={(record) => JSON.stringify([record.employee.id, record.dpi.id])}
      searchQueryName={null}
      readOnly
    />
  );
}
